// @flow
import React from 'react'
import type { Props } from './types'

import Clean from './variants/Clean'
import Complex from './variants/Complex'

export default (props: Props): React$Node => <Clean {...props} />
